import { render, staticRenderFns } from "./CustomerIdentificationModal.vue?vue&type=template&id=7cdf9b44&scoped=true"
import script from "./CustomerIdentificationModal.vue?vue&type=script&lang=js"
export * from "./CustomerIdentificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdf9b44",
  null
  
)

export default component.exports